import {
  Autocomplete,
  FormHelperText,
  IconButton,
  TextField,
} from "@mui/material";
import { RevenueCenterType } from "@src/components/shared-containers/LocationSelectorDialog/types";
import AlertTriangle from "@src/assets/icons/AlertTriangle";
import Colors from "@src/constants/Colors";
import { useEffect, useState } from "react";
import { StyledFormControl } from "./styles";

interface AutoCompleteFieldProps {
  disabled: boolean;
  value: string;
  label: string;
  options: RevenueCenterType[];
  handleChange: (value: string) => void;
  PopupIcon: JSX.Element;
  ClearIcon: React.FunctionComponent;
  nodata: boolean;
}

const AutoCompleteField = ({
  disabled,
  value,
  label,
  options,
  handleChange,
  PopupIcon,
  ClearIcon,
  nodata,
}: AutoCompleteFieldProps) => {
  const [errorStr, setErrorStr] = useState("");

  useEffect(() => {
    if (nodata) setErrorStr("Error! No data available");
  }, [nodata]);

  return (
    <StyledFormControl
      disabled={disabled}
      fullWidth
      value={value}
      error={errorStr.length > 0}
      nodata={nodata ? "true" : ""}
    >
      <Autocomplete
        disablePortal
        disabled={nodata || disabled}
        selectOnFocus={false}
        value={value === "" ? null : value}
        popupIcon={
          // eslint-disable-next-line no-nested-ternary
          nodata ? (
            <IconButton>
              <AlertTriangle
                color={Colors.error_500}
                width="24px"
                height="24px"
                strokeWidth="1.2px"
              />
            </IconButton>
          ) : value === "" ? (
            PopupIcon
          ) : null
        }
        clearIcon={<ClearIcon />}
        onChange={(
          _event: React.SyntheticEvent<Element, Event>,
          newValue: string | null
        ) => {
          handleChange(newValue || "");
          setErrorStr("");
        }}
        fullWidth
        options={options?.map((center) => center.rvc_name)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder="Select or Search by keyword"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            sx={{
              input: {
                "&::placeholder": {
                  opacity: 1,
                },
              },
            }}
          />
        )}
      />
      <FormHelperText>{nodata && errorStr}</FormHelperText>
    </StyledFormControl>
  );
};

export default AutoCompleteField;
